<template>
  <div class="top">
    <!-- <div class="input">
      <input
        type="number"
        class="w70"
        :readonly="isReadOnly"
        @input="changeCheck($event)"
        :value="amount('client')"
        ref="numberinput"
        min='0'
        @focus="magic_flag = true"
        @blur="hideMagicFlag"
        :class="whichClass()"
      >
    </div>
    <div class="focus-contain" v-bind:class="{ active: magic_flag}">
      <div class="focus-contain-div">
        <div class="focus-contain-close" v-if="column === 'extra_charges'">
        <svgicon name="cancelblack" width="10" height="10" @click='magic_flag = false' :original="true" />
       </div>
        <div class="focus-contain-div-list" v-for="(option, index) in options" :key="index">
          <div :class="option.fontweight">{{option.value}}</div>
          <span class="focus-contain-div-text">{{option.label}}</span>
        </div>
        <div class="text-areablock" v-if="commentShow">
          Comments:<br/>
        <textarea rows="3" v-model="misc_comments" cols="30">Comments</textarea>
        <div class="focus-contain-btn">
        <button class="btn btn-primary" v-if="misc_comments && misc_comments.length > 2" @click='addComments()'>Submit</button>
      </div>
      </div>
    </div>
  </div> -->

  <Popover placement="bottom" popper-class="newpopover tooltippopover">
        <div class="popover-primary">
          <div class="">
            <div class="focus-contain" v-bind:class="{ active: magic_flag}">
              <div class="focus-contain-div">
                <div class="focus-contain-close" v-if="column === 'extra_charges'">
                <svgicon name="cancelblack" width="10" height="10" @click='magic_flag = false' :original="true" />
               </div>
                <div class="focus-contain-div-list" v-for="(option, index) in options" :key="index">
                  <div :class="option.fontweight">{{option.value}}</div>
                  <span class="focus-contain-div-text">{{option.label}}</span>
                </div>
                <div class="text-areablock" v-if="commentShow">
                  Comments:<br/>
                <textarea rows="3" v-model="misc_comments" cols="50">Comments</textarea>
                <div class="focus-contain-btn">
                <button class="btn btn-primary" v-if="misc_comments && misc_comments.length > 2" @click='addComments()'>Submit</button>
              </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div slot="reference">
          <div class="input">
            <input
              type="number"
              class="w70"
              :readonly="validateReadOnlyOnOldPayment(isReadOnly) || this.$hasFeature('edit_invoice_post_invoice')"
              @input="changeCheck($event)"
              :value="amount('client')"
              ref="numberinput"
              min='0'
              @focus="magic_flag = true"
              @blur="hideMagicFlag"
              :class="whichClass()"
            >
          </div>
        </div>
      </Popover>


  </div>
</template>
<script>
import debounce from 'debounce';
import { getStatusByName } from '@common/lib/payments';

export default {
  props: {
    columnDetails: { type: Object, default: () => {} },
    payment: Object,
    consigneeIndex: {
      type: Number,
      default: 0,
    },
    isReadOnly: Boolean,
    compareBy: { type: Boolean, default: false },
    invoiceStatus: { type: Number },
  },
  data() {
    return {
      magic_flag: false,
      column: this.columnDetails.column,
      label: this.columnDetails.label || '',
      action: this.columnDetails.action || '',
      commentShow: this.columnDetails.comments || false,
      commentpop: false,
      misc_comments: null,
      daysCheck: ['transit_charge', 'arrival_charge', 'loading_detention_charge', 'unloading_detention_charge'],
      quantityCheck: ['shortage_charge', 'damage_charge', 'leakage_charge', 'carton_damage_charge'],
    };
  },
  methods: {
    addComments() {
      this.$emit('addConversation', this.misc_comments);
      this.magic_flag = false;
      this.misc_comments = null;
    },
    amount(section) {
      const total = this.payment[this.column] ? this.payment[this.column][section] : 0;
      return total > 0 ? Number(total.toFixed(2)) : 0;
    },
    whichClass() {
      let sectionClass = {
        'primary-text': this.amount('transporter') !== this.amount('system'),
      };
      if ((this.compareBy || this.invoiceStatus > getStatusByName('checked').id) &&
        this.amount('transporter') !== this.amount('client')) {
        // sectionClass = {};
        switch (this.action) {
          case 'decrement': {
            sectionClass = {
              'green-color': this.amount('transporter') > this.amount('client'),
              'error-text': this.amount('transporter') < this.amount('client'),
            };
            break;
          }
          case 'increment': {
            sectionClass = {
              'error-text': this.amount('transporter') > this.amount('client'),
              'green-color': this.amount('transporter') < this.amount('client'),
            };
            break;
          }
          case 'detect_check': {
            sectionClass = {
              'error-text': this.amount('transporter') < this.amount('client'),
              'green-color': this.amount('transporter') > this.amount('client'),
            };
            break;
          }
          case 'no_check': {
            sectionClass = {
              'error-text': this.amount('transporter') > this.amount('client'),
              'green-color': this.amount('transporter') < this.amount('client'),
            };
            break;
          }
          default:
        }
      }
      return Object.assign(sectionClass, {
        'read-text': this.validateReadOnlyOnOldPayment(this.isReadOnly),
        activeborder: this.magic_flag,
      });
    },
    hideMagicFlag: debounce(function debounceSearch() {
      this.magic_flag = !!(this.commentShow);
    }, 100),

    changeCheck: debounce(function debounceSearch(event) {
      if (!this.compareBy) {
        this.$emit('updateCompareBy', this.column);
      }
      const value = Number(event.target.value).toFixed(3);
      let changeStatus = false;
      if (this.action === 'decrement') {
        changeStatus = this.decrementCheck(value);
      } else if (this.action === 'increment') {
        changeStatus = this.incrementCheck(value);
      } else {
        changeStatus = value;
      }
      if (changeStatus) {
        this.$emit('updateClientAmount', {
          column: this.column,
          value,
          indentDetails: {
            consignee_id: this.payment.destination_location_id,
            order_no: this.payment.order_number,
          },
        });
      }
    }, 600),
    decrementCheck(value) {
      if (value > this.amount('transporter')) {
        this.$error({
          message: `${
            this.label
          } Charge cannot be higher than 'Transporter requested'`,
        });
      }
      return !(value > this.amount('transporter'));
    },
    incrementCheck(value) {
      if (value < this.amount('transporter')) {
        this.$error({
          message: `${
            this.label
          } Charge cannot be lesser than 'Transporter requested'`,
        });
      }
      return !(value < this.amount('transporter'));
    },
    validateReadOnlyOnOldPayment(readonly) {
      if (readonly) {
        return true;
      }
      return !!_.isEmpty(this.payment[this.column]);
    },
  },
  computed: {
    checkDataType() {
      let result = {};

      if (
        this.payment.client[this.column].days ||
        this.payment.client[this.column].days === 0
      ) {
        result = {
          label: 'Days',
          value: this.payment.client[this.column].days,
        };
      } else if (
        this.payment.client[this.column].qty ||
        this.payment.client[this.column].qty === 0
      ) {
        result = { label: 'Quantity', value: this.payment.client[this.column].qty };
      } else {
        result = { label: '', value: 0 };
      }
      return result;
    },
    options() {
      const options = [];
      if (this.daysCheck.includes(this.column)) {
        const splitColumn = this.column.split('_', 1);
        const delayRate = this.payment.days_damage[`${splitColumn}_delay`];
        if (delayRate) {
          options.push({
            value: delayRate,
            label: 'Days',
            fontweight: 'primary-text bold',
          });
        }
      }
      if (this.quantityCheck.includes(this.column)) {
        const splitColumn = this.column.split('_');
        const lastNameRemovedColumn = splitColumn.slice(0, splitColumn.length - 1).join('_');
        const qtyRate = this.payment.days_damage[lastNameRemovedColumn];
        if (qtyRate) {
          options.push({
            value: qtyRate,
            label: 'Quantity',
            fontweight: 'primary-text bold',
          });
        }
      }
      if (this.amount('transporter')) {
        options.push({
          value: this.amount('transporter'),
          label: 'Transporter',
          fontweight: 'primary-text bold',
        });
      }
      if (this.amount('system')) {
        options.push({
          value: this.amount('system'),
          label: 'System',
          fontweight: 'sec-text italics',
        });
      }
      return options;
    },
  },
};
</script>
<style lang="scss" scoped>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

input {
  border-color: transparent;
  background-color: transparent;
  outline: none;
  color: #404040;
}
.red-border {
  background-color: #dbdbdb;
  font-family:$fontSemibold;
}
.top {
  padding-top: 0px;
}
.order-content {
  .el-popover__reference {
    cursor: pointer;
    padding: 2px 0;
  }
  .table-row {
    //padding: 0 15px;
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
.payment-popover {
  h3 {
    padding-left: 15px;
    text-transform: uppercase;
  }
  &.popover-primary {
    padding: 20px 20px 20px 10px;
  }
}
.primary-text {
  color: #008aff !important;
  font-family:$fontSemibold;
}
.sec-text {
  color: #969696;
  font-family:$fontSemibold;
}
.green-text {
  color: #04a537 !important;
  font-family:$fontSemibold;
  margin-top: 0px;
}
.green-color {
  color: #04a537 !important;
  font-family:$fontSemibold;
  margin-top: 0px;
}
.error-text {
  color: #e74c3c !important;
  font-family:$fontSemibold;
  margin-top: 0px;
}

.focus-contain {
  //display: none;
  .primary-text {
    text-align: right;
    font-style: italic;
    color: #a3a3a3 !important;
  }
  .sec-text {
    text-align: right;
    font-style: italic;
    color: #234357;
  }
  &-close{
      text-align: right;
      padding: 10px 10px 5px 5px;
      cursor: pointer;
    }
  &-div {
    background-color: #fff;
    position: absolute;
    box-shadow: 0 0 30px 2px rgba(209, 208, 208, 0.5);
    margin-left: -10px;
    // padding-right: 10px;
    margin-top: 5px;
    display: block;
    //width: 132px;
    min-width: 80px;
    border-top: 1px solid #efefef;

    &-list {
      // padding: 7px 0;
      // padding: 10px 15px;
      padding-top: 6px;
        padding: 9px 5px;
      font-size: 1.2rem;
    }
    &-list:last-child {
      padding-bottom: 10px;
    }
    &-text {
      color: #404040;
      font-size: 0.8rem;
      display: block;
      line-height: 20px;
      padding: 0;
      letter-spacing: 1px;
      text-transform: uppercase;
      text-align: right;
    }
  }
  .input {
    border-bottom: 1px solid #efefef;
    padding-bottom: 0;
    padding-right: 0;
  }
}

.comment-pop{
    display: inline-block;
  }
  .text-areablock{
    padding: 0 10px 20px;
    textarea{
    border: 1px solid #D7D7D7;
    margin: 10px 5px;
    padding: 10px 5px;
  }
  .focus-contain-btn{
    text-align: right;
    padding-right: 5px;
  }
  }
.active {
  //width: 122px;
  display: block;
  height: 40px;
  position: absolute;
  vertical-align: middle;
  margin-top: 5px;
  //-webkit-box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
  //box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
  input {
    background: #fff;
    height: 40px;
    margin-top: -10px;
    //width: 133px;
    padding-left: 10px;
    margin-left: -11px;
    // padding-right: 5px;
    min-width: 110px;
  }
}
.read-text {
  color: #234357;
  font-family:$fontSemibold;
}
.activeborder {
  border: 1px solid #007fea !important;
  height: 40px !important;
}
.comment-inputfield{
  display: inline-block;
}
</style>
